export const stateName = 'location';